/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Press Releases - CamAPS FX',
    titleMeta: 'Press Releases - CamAPS FX',
    descriptionMeta: 'Latest press releases and news from CamAPS FX.',
    keywords: 'camaps press releases, camaps news, diabetes technology news',
    localeMeta: 'en_gb',

    bannerTitle: 'Press releases',
    bannerSubtitle: 'Keep up to date with our latest announcements',

    contactText: 'For any press enquiries please contact via <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'All press releases are published in English.',

    download: 'Download',
    showMore: 'Show more',
    showLess: 'Show less',
};

